export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/865622b54fec272e12245ed26e84af24.png";